module.exports = __webpack_public_path__ + "img/protect.4f666be6.png";